import * as React from 'react';

import Popover from 'components/popover/Popover';
import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';

import ContentApprovalAsset from './ContentApprovalAsset';

import type { ClientApprovalBucketItem, GalleryModalItem } from 'types';

import type { SyntheticEvent } from 'react';

type Props = {
  item: ClientApprovalBucketItem,
  galleryItems: Array<GalleryModalItem>,
  galleryItemIndex: number,
  onUnsortedItemSelect: (a: number) => void
};

class ContentApprovalUnsortedItem extends React.PureComponent<Props> {
  handleSelect = (event: SyntheticEvent<HTMLElement>): void => {
    const { onUnsortedItemSelect } = this.props;
    const target = event.currentTarget;
    const selectedIndex = Number(target.dataset.index);

    onUnsortedItemSelect(selectedIndex);
  };

  renderCheckbox(): React.ReactNode {
    const { item, galleryItemIndex } = this.props;

    return (
      <div
        className="content-approval-unsorted-item__footer"
        onClick={this.handleSelect}
        data-index={galleryItemIndex}
        data-selected={item.isSelected}
      >
        <InputCheckbox
          key={`content-approval-unsorted-item-checkbox-${item.id}`}
          id={`content-approval-unsorted-item-checkbox-${item.id}`}
          name="content-approval-unsorted-item-checkbox"
          value={String(item.isSelected)}
          checked={item.isSelected}
          labelClass="content-approval-unsorted-item__label"
        />
      </div>
    );
  }

  renderAsset(): React.ReactNode {
    const { item, galleryItems, galleryItemIndex } = this.props;

    return (
      <React.Fragment>
        <ContentApprovalAsset
          item={item}
          galleryItems={galleryItems}
          galleryItemIndex={galleryItemIndex}
          onUnsortedItemSelect={this.handleSelect}
          showOverlay
        />
        {this.renderCheckbox()}
      </React.Fragment>
    );
  }

  renderItem(): React.ReactNode {
    const { item } = this.props;

    return item.fileName ? (
      <Popover
        triggerComponent={this.renderAsset()}
        classNamePopover="content-approval-unsorted-item__popover"
      >
        { // $FlowIgnore - There is check for undefined or null still it complains about children being null
         item.fileName
        }
      </Popover>) :
      this.renderAsset();
  }

  render(): React.ReactNode {
    return (
      <div className="content-approval-unsorted-item">
        {this.renderItem()}
      </div>
    );
  }
}

export default ContentApprovalUnsortedItem;
